<template>
  <div class="call-ui">
    <audio ref="call"/>
    <div class="controls-wrapper">
      <i :class="volumeIcon" class="glyphicon" @click="volume = 0"></i>
      <input v-model="volume" max="1" min="0" step="0.1" style="display: inline-block" type="range"
        @input="changeVolume">
      <i :class="{red: !mic}" class="glyphicon glyphicon-earphone" @click="toggleMic"></i>
    </div>
    <div v-if="callStatus==='no-call' && !isFigurant">{{ translate('callUi.noCall') }}</div>
    <template v-else-if="callStatus==='ring'">
      <div v-if="call.initiator">
        {{ translate('callUi.calling') }} {{ callerName }}...
        <button class="btn btn-sm btn-danger" @click="hang">{{ translate('callUi.hangUp') }}</button>
      </div>
      <div v-else>
        {{ translate('callUi.callFrom') }} {{ callerName }}
        <br/>
        <button :class="{disabled: this.settingUp}" class="btn btn-sm btn-success" @click="accept">
          {{ translate('callUi.accept') }}
        </button>
        <button class="btn btn-sm btn-danger ml-2" @click="hang">{{ translate('callUi.decline') }}</button>
      </div>
    </template>
    <div v-if="callStatus==='connecting'">
      {{ translate('callUi.establishing') }}
      <button class="btn btn-sm btn-danger" @click="hang">{{ translate('callUi.hangUp') }}</button>
    </div>
    <div v-if="callStatus==='connected'">
      {{ translate('callUi.inCallWith') }} {{ callerName }}.
      <button class="btn btn-sm btn-danger" @click="hang">{{ translate('callUi.hangUp') }}</button>
      <div>{{ callTimeHuman }}</div>
    </div>
  </div>
</template>

<script>
import eventHub from "@/mixins/eventHub";
import draggable from '@/mixins/draggable.js'
import getPropertyValue from '@/mixins/getPropertyValue.js';

export default {
  name: "CallUI",
  props: {
    event: Object,
  },
  data() {
    return {
      settingUp: false,
      volume: 1,
      mic: true,
      callDuration: 0,
      callTrackerIntervalId: null,
      callerName: ''
    }
  },
  computed: {
    volumeIcon() {
      if (this.volume > .5) {
        return 'glyphicon-volume-up'
      }
      else if (this.volume > .0) {
        return 'glyphicon-volume-down'
      }
      else {
        return 'glyphicon-volume-off'
      }
    },
    call() {
      return this.$store.state.call
    },
    callStatus() {
      if (!this.$store.state.call) return 'no-call'
      else return this.$store.state.call.status
    },
    isFigurant() {
      return this.$store.state.scenarioSelectedRole === 5
    },
    eventPublicId() {
      return this.getPropertyValue(this.event, "cisloVyzvy");
    },
    callTimeHuman() {
      return new Date(this.callDuration * 1000).toISOString().substr(14, 5) // mm:ss
    }
  },
  methods: {
    startTrackingTime() {
      if (this.callTrackerIntervalId === null) {
        this.callTrackerIntervalId = setInterval(() => {
          this.callDuration += 1;
        }, 1000)
      }
    },
    getCallerName() {
      if (this.call) {
        if (this.call.myRole === 'call-taker' && this.call.event) {
          const event = this.$store.getters.getEntity(this.call.eventId)
          if (event.properties.volajici) {
            return `${event.properties.telefon ? event.properties.telefon : ''}${event.properties.volajici ? ' ' + event.properties.volajici : ''}`
          }
          else if (event.properties.telefon) {
            return event.properties.telefon
          }
          return 'unknown'
        }
        if (this.call.myRole === 'figurant') {
          return this.call.to.email
        }
      }
    },
    getPropertyValue,
    // Unused
    toggleMic() {
      this.mic = !this.mic
      if (this.$store.state.micStream) {
        this.$store.state.micStream.getAudioTracks().forEach((track) => {
          track.enabled = this.mic
        })
      }
    },
    changeVolume(event) {
      this.$refs['call'].volume = event.target.value
    },
    hang() {
      if (this.call) {
        this.$store.dispatch('hangupCall')
        if (this.callTrackerIntervalId) {
          this.clearInterval(this.callTrackerIntervalId)
        }
      }
    },
    async accept() {
      if (this.settingUp) return
      this.settingUp = true
      await this.$store.dispatch('acceptCall')
      this.callerName = this.getCallerName()
      this.startTrackingTime()
      this.settingUp = false
    },
    // Triggered when eventHub fires callReady events. Call.js is firing this event once webRTC finishes establishing
    onCallReady(event) {
      this.$refs['call'].srcObject = event.streams[0]
      this.$refs['call'].play()
    },
  },
  created() {
    eventHub.$on('callReady', this.onCallReady)
  },
  destroyed() {
    eventHub.$off('callReady', this.onCallReady)
  },
  mounted() {
    Array.from(document.getElementsByClassName("call-ui-wrapper")).forEach(el => {
      draggable(el);
    });
  }
}
</script>

<style lang="less" scoped>
.controls-wrapper {
  display: flex;
  flex-flow: row nowrap;

  input {
    margin: 0em .75em 0 .25em;
  }

  i {
    font-size: 1.3em;
  }
}

.red {
  color: red;
}

.call-ui {
  padding: .3em;
  width: 350px;
  height: 80px;
  border: 1px solid black;
  border-radius: .5em;
  background-color: white;
  cursor: move;
}
</style>
